import React from 'react';
import ResourceList from './resource-list';

const InventoryList = (props) => (
    <ResourceList {...props} fields={['name']} path="/inventories/" />
);

export default InventoryList;